// src/App.jsx
// ...existing code...
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/styles.css";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import AddWine from "./pages/AddWine";
import Product from "./pages/Product";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Orders from "./pages/Orders";
import EditWine from "./pages/EditWine";
import OrderResult from "./pages/OrderResult";
import Search from "./pages/Search";

import AdminLayout from "./admin/AdminLayout";
import OrdersAdmin from "./admin/OrdersAdmin";
import Categories from "./pages/Categories";
import CategoryPage from "./pages/CategoryPage";
import TypePage from "./pages/TypePage";
// 🔹 POS + Inventaire
import POS from "./pages/POS";
import Cash from "./pages/Cash";
import Stock from "./pages/Stock";
import Purchases from "./pages/Purchases";
import ReceiptsList from "./pages/ReceiptsList";

// 🔹 Inventaire / PO
import PurchaseOrders from "./pages/PurchaseOrders";
import Inventory from "./pages/Inventory";
import InventoryEditItem from "./pages/InventoryEditItem";
import InventoryStockSheet from "./pages/InventoryStockSheet";
import POReception from "./pages/POReception"; // (si tu la gardes encore)

// 🔹 NOUVELLES PAGES PO/Shipping
import POEditor from "./pages/POEditor";               // création / édition d’un PO
import POShip from "./pages/POShip";                   // expédition (ship) d’un PO
import ShipmentReceive from "./pages/ShipmentReceive"; // réception d’un shipping
import ShipmentCreateMulti from "./pages/ShipmentCreateMulti";
import ShipmentsList from "./pages/ShipmentsList";
import ShipmentDetails from "./pages/ShipmentDetails";

import QuickAddItemEK from "./pages/QuickAddItemEK";
import AdminRoles from "./admin/AdminRoles";
import RequireRole from "./components/RequireRole";

import { CartProvider } from "./context/CartContext";
import Login from "./pages/Login";
import AdminCashReport from "./pages/AdminCashReport";


export default function App() {
  return (
    <Router>
      <CartProvider>
        <Header />
        <main className="container py-4" style={{ minHeight: "70vh" }}>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/category/:id" element={<CategoryPage />} />
            <Route path="/type/:type" element={<TypePage />} />  {/* 👈 ICI */}
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/order-result" element={<OrderResult />} />
            <Route path="/add" element={<AddWine />} />
            <Route path="/edit/:id" element={<EditWine />} />
            <Route path="/search" element={<Search />} />
            <Route path="/login" element={<Login />} />

            {/* 🔹 POS + Inventaire (protégé) */}
            <Route
              path="/pos"
              element={
                <RequireRole anyOf={["cashier", "manager", "admin"]}>
                  <POS />
                </RequireRole>
              }
            />
            <Route
              path="/cash"
              element={
                <RequireRole anyOf={["cashier", "manager", "admin"]}>
                  <Cash />
                </RequireRole>
              }
            />
            <Route
              path="/stock"
              element={
                <RequireRole anyOf={["manager", "admin"]}>
                  <Stock />
                </RequireRole>
              }
            />
            <Route
              path="/purchases"
              element={
                <RequireRole anyOf={["manager", "admin"]}>
                  <Purchases />
                </RequireRole>
              }
            />
            <Route
              path="/receipts"
              element={
                <RequireRole anyOf={["cashier", "manager", "admin"]}>
                  <ReceiptsList />
                </RequireRole>
              }
            />

            {/* Dev / utilitaires (TOP-LEVEL) */}
            <Route path="/dev/add-item" element={<QuickAddItemEK />} />

            {/* Admin (protégé globalement : manager/admin) */}
            <Route
              path="/admin"
              element={
                <RequireRole anyOf={["manager", "admin"]}>
                  <AdminLayout />
                </RequireRole>
              }
            >
              <Route index element={<OrdersAdmin />} />
              <Route path="orders" element={<OrdersAdmin />} />
              <Route path="wines" element={<AddWine />} />
              <Route path="categories" element={<Categories />} />

              {/* 🔹 POS dans l'espace admin */}
              <Route
                path="pos"
                element={
                  <RequireRole anyOf={["cashier", "manager", "admin"]}>
                    <POS />
                  </RequireRole>
                }
              />
              <Route
                path="cash"
                element={
                  <RequireRole anyOf={["cashier", "manager", "admin"]}>
                    <Cash />
                  </RequireRole>
                }
              />
              <Route
                path="stock"
                element={
                  <RequireRole anyOf={["manager", "admin"]}>
                    <Stock />
                  </RequireRole>
                }
              />
              <Route
                path="purchases"
                element={
                  <RequireRole anyOf={["manager", "admin"]}>
                    <Purchases />
                  </RequireRole>
                }
              />
              <Route
                path="receipts"
                element={
                  <RequireRole anyOf={["cashier", "manager", "admin"]}>
                    <ReceiptsList />
                  </RequireRole>
                }
              />

              {/* 🔹 Inventaire & PO */}
              <Route
                path="inventory"
                element={
                  <RequireRole anyOf={["cashier", "manager", "admin"]}>
                    <Inventory />
                  </RequireRole>
                }
              />
              <Route
                path="inventory/item/:itemId/edit"
                element={<InventoryEditItem />}
              />
              <Route
                path="inventory/item/:itemId/stock"
                element={<InventoryStockSheet />}
              />
              <Route
                path="purchase-orders"
                element={
                  <RequireRole anyOf={["manager", "admin"]}>
                    <PurchaseOrders />
                  </RequireRole>
                }
              />

              {/* ✅ NOUVELLES ROUTES : PO Editor / Ship / Shipment Receive */}
              {/* Créer un PO */}
              <Route
                path="po/new"
                element={
                  <RequireRole anyOf={["manager", "admin"]}>
                    <POEditor mode="create" />
                  </RequireRole>
                }
              />
              {/* Éditer un PO */}
              <Route
                path="po/:poId/edit"
                element={
                  <RequireRole anyOf={["manager", "admin"]}>
                    <POEditor mode="edit" />
                  </RequireRole>
                }
              />
              {/* Expédier (ship) un PO */}
              <Route
                path="po/:poId/ship"
                element={
                  <RequireRole anyOf={["manager", "admin"]}>
                    <POShip />
                  </RequireRole>
                }
              />
              <Route path="ship/new" element={<ShipmentCreateMulti />} />
              <Route path="/admin/shipments" element={<ShipmentsList />} />
              <Route path="/admin/shipments/:id" element={<ShipmentDetails />} />
              {/* Réceptionner un shipping */}
              <Route
                path="shipments/:shipId/receive"
                element={
                  <RequireRole anyOf={["manager", "admin"]}>
                    <ShipmentReceive />
                  </RequireRole>
                }
              />

              {/* (Optionnel) Ancienne page de réception directement par PO */}
              <Route
                path="po/:poId"
                element={
                  <RequireRole anyOf={["manager", "admin"]}>
                    <POReception />
                  </RequireRole>
                }
              />

              {/* 👥 Gestion des rôles (admin only) */}
              <Route
                path="roles"
                element={
                  <RequireRole anyOf={["admin"]}>
                    <AdminRoles />
                  </RequireRole>
                }
              />
              {/* 🔹 Rapport de caisse (admin only) */}
              <Route
                path="/admin/cash-report"
                element={
                  <RequireRole anyOf={["admin"]}>
                    <AdminCashReport />
                  </RequireRole>
                }
              />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </CartProvider>
    </Router>
  );
}
// ...existing code...